var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.455,
    height: 26.015,
    viewBox: "0 0 37.455 26.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31897",
    x: 0,
    y: 0,
    width: 37.455,
    height: 26.015,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZA-Flag",
    transform: "translate(1.456 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.46, -0.5)",
    filter: "url(#Rectangle_31897)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31897-2",
    "data-name": "Rectangle 31897",
    width: 34.455,
    height: 23.015,
    transform: "translate(1.5 0.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40590",
    "data-name": "Path 40590",
    d: "M.007,0V2.762l12.74,8.745L.007,20.254v2.761H4.03l13.412-8.945H34.425V8.9H17.441L4.03,0Z",
    transform: "translate(0.009)",
    fill: "#063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40591",
    "data-name": "Path 40591",
    d: "M14.22,6.751,3.042,14.209H30.755V6.751Z",
    transform: "translate(3.678 8.807)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40592",
    "data-name": "Path 40592",
    d: "M3.042,0,14.22,7.456H30.755V0Z",
    transform: "translate(3.678)",
    fill: "#c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40593",
    "data-name": "Path 40593",
    d: "M0,3.072l10.069,6.965L0,17.005v1.857l12.753-8.825L0,1.215Z",
    transform: "translate(0 1.469)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40594",
    "data-name": "Path 40594",
    d: "M0,16.093,10.069,9.06,0,2.025Z",
    transform: "translate(0 2.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40595",
    "data-name": "Path 40595",
    d: "M1.828,0,15.239,8.95H32.223V7.456H15.688L4.51,0Z",
    transform: "translate(2.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40596",
    "data-name": "Path 40596",
    d: "M15.24,6.076,1.828,15.025H4.51L15.686,7.567H32.223V6.076Z",
    transform: "translate(2.211 7.99)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaFlag);
export default __webpack_public_path__ + "static/media/ZA-Flag.a25304a56ae125f6388cf58e79818cd2.svg";
export { ForwardRef as ReactComponent };